<template>
  <div class="login-container">
    <v-row class="fill-height ma-0">
      <!-- Left Section - Login Form -->
      <v-col cols="12" md="6" class="d-flex justify-center align-center pa-8">
        <v-card elevation="0" width="100%" max-width="450">
          <v-card-title class="d-flex justify-center align-start flex-column">
            <div class="mainTitle font-weight-bold" style="font-size: 34px">{{ title }}</div>
            <div class="text-subtitle-1">Enter your account no. and password to log in!</div>
          </v-card-title>
          <div style="min-height: 300px">
            <v-slide-x-transition mode="out-in">
              <!-- <v-form
                key="forgotPwdForm"
                v-if="isForgetPassword"
                @submit.prevent="submitForgetPassword"
              >
                <v-container>
                  <v-row dense>
                    <v-col cols="12">
                      <ValidationObserver ref="forgotPwdForm" v-slot="{ invalid }">
                        <ValidationProvider v-slot="{ errors }" name="Email" rules="email|required">
                          <label-with-text-field
                            item-field-name="Email Address"
                            v-model="forgetUserEmail"
                            :error-messages="errors"
                          />
                        </ValidationProvider>
                      </ValidationObserver>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-space-between align-center">
                    <v-btn depressed @click="isForgetPassword = false">Back</v-btn>
                    <v-btn depressed @click="submitForgetPassword" color="primary">Submit</v-btn>
                  </div>
                </v-container>
              </v-form> -->
              <v-form key="loginForm" @submit.prevent="submit" ref="form">
                <v-container>
                  <v-row class="mb-4">
                    <v-col cols="12">
                      <FletrixTextField
                        placeholder="Mobile no."
                        v-model="account"
                        outlined
                        :rules="rules"
                        label="*Account no."
                      />
                    </v-col>
                    <v-col cols="12">
                      <FletrixTextField
                        v-model="password"
                        placeholder="Password"
                        outlined
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="passRules"
                        :type="show ? 'text' : 'password'"
                        required
                        @click:append="show = !show"
                        label="*Password"
                      ></FletrixTextField>
                    </v-col>
                  </v-row>
                  <!-- <div class="text-center mb-4">
                    <v-btn @click="forget" text color="#C7A0CB" class="pa-1">forget password</v-btn>
                  </div> -->
                  <div class="d-flex align-center justify-center">
                    <v-btn type="submit" color="primary" x-large class="px-8 full-width">
                      LOGIN
                    </v-btn>
                  </div>
                  <div v-if="showErr" class="errMessage text-center mt-4">{{ showErr }}</div>
                </v-container>
              </v-form>
            </v-slide-x-transition>
          </div>
        </v-card>
      </v-col>

      <!-- Right Section - Brand Display -->
      <v-col cols="12" md="6" class="brand-section d-none d-md-flex">
        <div class="brand-content">
          <img :src="logoImage" alt="Raphael Medical Logo" class="brand-logo" />
          <!-- <h1 class="brand-title">Raphael Medical</h1> -->
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from '@/api';
import { ssoLogin /*, forgetPassword*/ } from '@/api/auth/sso';
import { mapActions } from 'vuex';
import { rule_email } from '@/services/utils.js';
import { FletrixTextField } from '@/components/Atom';
import logoImage from '@/assets/Logo/logo4.png';

export default {
  components: { FletrixTextField },
  props: {
    ret: {},
  },
  data() {
    return {
      logoImage,
      account: '',
      rules: [
        value => !!value || 'Required.',
        //value => (value && value.length >= 1) || 'Min 1 characters',
      ],
      show: false,
      check: false,
      password: '',
      remember: true,
      showErr: null,
      passRules: [
        value => !!value || 'Required.',
        //value => (value && value.length >= 8) || 'Min  characters',
      ],
      // isForgetPassword: false,
      // forgetUserEmail: null,
      // emailRule: rule_email,
    };
  },
  mounted() {
    // Check if there's a clinic_not_vip error in query params
    if (this.$route.query.error === 'clinic_not_vip') {
      this.showErr = 'Your clinic VIP is not valid, please contact admin';
    }
  },
  computed: {
    title() {
      // return this.isForgetPassword ? 'FORGOT PASSWORD' : 'LOGIN';
      return 'LOGIN';
    },
  },
  methods: {
    ...mapActions('auth', ['checkLoginStatus']),
    async submit() {
      try {
        this.$refs.form.validate();

        // Format phone number if needed
        let formattedAccount = this.account;
        if (!formattedAccount.startsWith('+') && /^\d+$/.test(formattedAccount)) {
          if (formattedAccount.length === 11) {
            formattedAccount = '+' + formattedAccount;
          } else if (formattedAccount.length === 8) {
            formattedAccount = '+852' + formattedAccount;
          }
        }

        const Credential = {
          auto: formattedAccount,
          pw: this.password,
          remember: this.remember,
        };
        await ssoLogin(api, Credential);
        await this.checkLoginStatus();
        await this.$router.push(this.ret || '/').catch(() => {});
      } catch (err) {
        switch (err.message) {
          case 'Invalid Credentials': {
            this.showErr = 'Incorrect Password';
            break;
          }
          case 'Missing credentials': {
            if (this.account === '') this.showErr = 'Please enter username and password ';
            else this.showErr = 'Please enter password ';
            break;
          }
          default:
            this.showErr = err.message;
        }
      }
    },
    // forget() {
    //   //this.$router.replace({ name: 'forgetpassword' }).catch(() => {});
    //   this.isForgetPassword = true;
    // },
    // async submitForgetPassword() {
    //   if (!(await this.$refs.forgotPwdForm.validate())) {
    //     return;
    //   }
    //   try {
    //     const result = await forgetPassword(api, { email: this.forgetUserEmail });
    //     if (result.data === true) {
    //       await this.$store.dispatch('alert/updateAlertMessage', {
    //         msg: 'An email has been sent to your email address.',
    //         type: 'success',
    //         color: 'success',
    //       });
    //     }
    //   } catch (err) {
    //     if (err?.message === 'not_found') {
    //       await this.$store.dispatch('alert/updateAlertMessage', {
    //         msg:
    //           'Email Not Found . Please double-check the email address you entered and try again.',
    //         type: 'error',
    //         color: 'error',
    //       });
    //     } else alert('action failed');
    //   }
    // },
  },
};
</script>
<style lang="scss">
.errMessage {
  font-weight: 600;
  color: var(--v-danger-base);
}
</style>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  width: 100%;
}

.brand-section {
  background: var(--v-primary-base);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 100px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.05);
  }
}

.brand-content {
  text-align: center;
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.brand-logo {
  max-width: 600px;
  height: auto;
  width: 100%;
}

.brand-title {
  color: #fff;
  font-family: Roboto;
  font-size: 52.633px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 52.633px */
}

@media (max-width: 960px) {
  .login-container {
    height: auto;
    min-height: 100vh;
  }
}
</style>
